
function PrivacyPage() {
    return (
        <div className="terms">
            <div className="container">
                <div className="termsMain">
                    <h2>Privacy Policy</h2>
                    <p>At Neethu's Academy, we are dedicated to safeguarding your privacy. This Privacy Policy outlines how we collect, use, and protect your personal information when you interact with our platform, which provides expert preparation for language proficiency and nursing exams such as OET, IELTS, PTE, TOEFL, and NCLEX-RN.</p>
                    <div className="termsList">
                        <h3>1. Information We Collect</h3>
                        <p>We collect various types of information to enhance your learning experience and improve our services:</p>
                        <div className="termsListBox">
                            <h4>a. Personal Information</h4>
                            <ul>
                                <li>
                                    <div className="icon"></div>
                                    <h5>Name, email address, phone number, and other contact details provided during registration or inquiries.</h5>
                                </li>
                                <li>
                                    <div className="icon"></div>
                                    <h5>Information related to your educational background, exam preferences, and goals shared through forms or applications.</h5>
                                </li>
                            </ul>
                        </div>
                        <div className="termsListBox">
                            <h4>b. Usage Data</h4>
                            <ul>
                                <li>
                                    <div className="icon"></div>
                                    <h5>Details about your interactions with the platform, such as visited pages, time spent, and other analytics.</h5>
                                </li>
                                <li>
                                    <div className="icon"></div>
                                    <h5>Device-specific information such as operating system, browser type, and IP address.</h5>
                                </li>
                            </ul>
                        </div>
                        <div className="termsListBox">
                            <h4>c. Payment Information</h4>
                            <ul>
                                <li>
                                    <div className="icon"></div>
                                    <h5>Billing details and transaction data collected securely if you enroll in paid courses or services.</h5>
                                </li>
                            </ul>
                        </div>
                        <div className="termsListBox">
                            <h4>d. Cookies and Similar Technologies</h4>
                            <ul>
                                <li>
                                    <div className="icon"></div>
                                    <h5>We may use cookies or similar technologies to enhance functionality, store preferences, and analyze user activity.</h5>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="termsList">
                        <h3>2. How We Use Your Information</h3>
                        <p>The information we collect is used to:</p>
                        <ul>
                            <li>
                                <div className="icon"></div>
                                <h5>Provide personalized recommendations and resources tailored to your learning needs.</h5>
                            </li>
                            <li>
                                <div className="icon"></div>
                                <h5>Facilitate course enrollments, assessments, and progress tracking.</h5>
                            </li>
                            <li>
                                <div className="icon"></div>
                                <h5>Communicate updates, announcements, and promotional materials (with your
                                    consent).</h5>
                            </li>
                            <li>
                                <div className="icon"></div>
                                <h5>Enhance the platform's functionality and user experience through analytics.</h5>
                            </li>
                            <li>
                                <div className="icon"></div>
                                <h5>Maintain platform security and prevent unauthorized access.</h5>
                            </li>
                        </ul>
                    </div>
                    <div className="termsList">
                        <h3>3. Sharing Your Information</h3>
                        <p>Your data is handled with strict confidentiality and is not sold or rented to third parties. However, it may be shared in the following scenarios:</p>
                        <ul>
                            <li>
                                <div className="icon"></div>
                                <h5><b>Service Providers:</b> To trust third-party vendors who assist in delivering our services (e.g., hosting or payment processing).</h5>
                            </li>
                            <li>
                                <div className="icon"></div>
                                <h5><b>Legal Compliance:</b> If required to comply with laws or respond to lawful requests from authorities.</h5>
                            </li>
                            <li>
                                <div className="icon"></div>
                                <h5><b>Business Transactions:</b> In the event of a merger or transfer of ownership, your data may be part of the transferred assets.</h5>
                            </li>
                        </ul>
                    </div>
                    <div className="termsList">
                        <h3>4. Data Security</h3>
                        <p>We implement industry-standard security measures to protect your personal information from unauthorized access, disclosure, or misuse. While we strive to ensure the highest level of security, no method of transmission over the internet is entirely secure.</p>
                    </div>
                    <div className="termsList">
                        <h3>5. Your Rights</h3>
                        <p>You have the following rights concerning your personal information:</p>
                        <ul>
                            <li>
                                <div className="icon"></div>
                                <h5><b>Access and Correction:</b> Request access to or correction of the personal data we hold about you.</h5>
                            </li>
                            <li>
                                <div className="icon"></div>
                                <h5><b>Deletion:</b> Request the deletion of your personal information where applicable.</h5>
                            </li>
                            <li>
                                <div className="icon"></div>
                                <h5><b>Opt-Out:</b> Unsubscribe from marketing communications or withdraw your consent
                                where required.</h5>
                            </li>
                            <li>
                                <div className="icon"></div>
                                <h5><b>Cookies:</b> Manage or disable cookies via your browser settings.</h5>
                            </li>
                        </ul>
                    </div>
                    <div className="termsList">
                        <h3>6. Data Retention</h3>
                        <p>We retain your personal information only for as long as it is necessary to fulfill the purposes outlined in this policy, unless a longer retention period is required by law.</p>
                    </div>
                    <div className="termsList">
                        <h3>7. Children’s Privacy</h3>
                        <p>Our platform is designed for adult learners and individuals preparing for professional exams. We do not knowingly collect personal information from children under the age of 13 without parental consent.</p>
                    </div>
                    <div className="termsList">
                        <h3>8. Updates to This Privacy Policy</h3>
                        <p>We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements. We encourage you to review this policy regularly for the latest updates.</p>
                    </div>
                    <div className="termsList">
                        <h3>9. Contact Us</h3>
                        <p>If you have any questions or concerns about this Privacy Policy or our data handling practices, please contact us at:</p>
                        <p>Email: <a href="mailto:hr@neethusacademy.com">hr@neethusacademy.com</a></p>
                        <p>Phone: <a href="tel:+919747944374">+91 9747 944 374</a></p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PrivacyPage;
